/** دکمهٔ «؟» در نوارِ بالا ⇒ راهنمای همین صفحه (v2.146.0). */
import React, { useMemo, useState } from "react";
import { Button, Drawer, Empty, Grid, Space, Tooltip } from "antd";
import { QuestionCircleOutlined, ReadOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { guideFor } from "./guides";
import GuideView from "./GuideView";

export default function GuideButton() {
  const loc = useLocation();
  const nav = useNavigate();
  const screens = Grid.useBreakpoint();
  const [open, setOpen] = useState(false);
  const g = useMemo(() => guideFor(loc.pathname, loc.search), [loc.pathname, loc.search]);
  return (
    <>
      <Tooltip title="راهنمای این صفحه">
        <button className="gx-icon-btn" onClick={() => setOpen(true)} aria-label="راهنمای این صفحه">
          <QuestionCircleOutlined />
        </button>
      </Tooltip>
      <Drawer open={open} onClose={() => setOpen(false)} placement="left" width={screens.md ? 640 : "100%"}
        title={<Space><QuestionCircleOutlined />{g ? `راهنما: ${g.title}` : "راهنما"}</Space>}
        extra={<Button icon={<ReadOutlined />} onClick={() => { setOpen(false); nav(`/guide${g ? `?g=${g.id}` : ""}`); }}>
          همهٔ راهنماها</Button>}>
        {g ? <GuideView guide={g} compact /> : (
          <Empty description="برای این صفحه هنوز راهنما نوشته نشده — «همهٔ راهنماها» را ببینید" />
        )}
      </Drawer>
    </>
  );
}
